// src/api.js
import axios from "axios";

import { baseUrl } from '../config/clientsConfig'

const leadSourceService = {
  fetchLeadSources: () => {
    return axios.get(`${baseUrl}/leadSources`);
  },
  addLeadSource: (name) => {
    return axios.post(`${baseUrl}/leadSource`, { name });
  },
  updateLeadSource: (id, name) => {
    return axios.put(`${baseUrl}/leadSource`, { id, name });
  },
};

export default leadSourceService;
